(function () {
  const container = document.getElementById('ToastContainer');
  const template = document.getElementById('ToastTemplate');

  if (!container || !template) return;

  const DEFAULT_DURATION = 5000;
  const LEAVE_ANIMATION_MS = 250;

  function dismissToast(toast) {
    if (!toast || toast.dataset.leaving === 'true') return;
    toast.dataset.leaving = 'true';
    toast.classList.remove('is-visible');
    toast.classList.add('is-leaving');
    window.setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
      
      // Hide the popover if there are no more toasts
      if (container.children.length === 0 && typeof container.hidePopover === 'function') {
        // Checking for matches(':popover-open') ensures we don't throw an error if it's already hidden
        try {
           container.hidePopover();
        } catch(e) {}
      }
    }, LEAVE_ANIMATION_MS);
  }

  function showToast(message, options) {
    if (!message) return;
    const opts = options || {};
    const duration = typeof opts.duration === 'number' ? opts.duration : DEFAULT_DURATION;

    const fragment = template.content.cloneNode(true);
    const toast = fragment.querySelector('.toast');
    const messageEl = fragment.querySelector('.toast__message');
    const closeBtn = fragment.querySelector('.toast__close');

    messageEl.textContent = message;

    if (opts.backgroundColor) {
      toast.style.setProperty('--toast-bg', opts.backgroundColor);
    }
    if (opts.iconColor) {
      toast.style.setProperty('--toast-icon-color', opts.iconColor);
    }

    closeBtn.addEventListener('click', function () {
      dismissToast(toast);
    });

    // Ensure the container is shown in the top layer before appending
    if (typeof container.showPopover === 'function') {
       try {
         container.showPopover();
       } catch(e) {}
    }

    container.appendChild(fragment);

    void toast.offsetWidth;
    toast.classList.add('is-visible');

    if (duration > 0) {
      window.setTimeout(function () {
        dismissToast(toast);
      }, duration);
    }

    return toast;
  }

  window.showToast = showToast;

  document.addEventListener('toast:show', function (event) {
    const detail = event.detail || {};
    showToast(detail.message, detail);
  });

  // Show a confirmation toast after a successful newsletter signup.
  // Shopify reloads the page with `?customer_posted=true` on success.
  const params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    showToast('Thank you for signing up!');
  }
})();
